import { useEffect, useState } from "react";
import { TabBar } from "../components/TabBar";
import { api } from "../api/client";
import type { WorkoutSession } from "../api/types";
import { useExerciseMap } from "../hooks/useExerciseLibrary";

export const History = () => {
  const [items, setItems] = useState<WorkoutSession[]>([]);
  const { map } = useExerciseMap();

  useEffect(() => {
    api<WorkoutSession[]>("/sessions").then(setItems).catch(() => {});
  }, []);

  return (
    <>
      <div className="page">
        <h1 className="h1">History</h1>
        <div className="muted">Past workouts (newest first)</div>

        <div style={{ marginTop: 16 }}>
          {items.length === 0 && <div className="muted">No workouts logged yet.</div>}
          {items.map((s) => {
            const completed = s.exercises
              .flatMap((e) => e.sets ?? [])
              .filter((set) => set.completed).length;
            const volume = s.exercises
              .flatMap((e) => e.sets ?? [])
              .filter((set) => set.completed)
              .reduce((a, set) => a + (set.weight ?? 0) * (set.reps ?? 0), 0);
            return (
              <div className="card" key={s.id}>
                <div className="row">
                  <strong>{s.date}</strong>
                  <div className="spacer" />
                  <span className="chip muted">{s.status}</span>
                </div>
                <div style={{ fontWeight: 700, marginTop: 4 }}>{s.name ?? "Workout"}</div>
                <div className="muted" style={{ marginTop: 4 }}>
                  {completed} sets · vol {Math.round(volume)}
                </div>
                <div className="muted" style={{ marginTop: 6, fontSize: 13 }}>
                  {s.exercises
                    .slice(0, 4)
                    .map((e) => map.get(e.exerciseId)?.name ?? e.exerciseId)
                    .join(" · ")}
                  {s.exercises.length > 4 ? ` +${s.exercises.length - 4} more` : ""}
                </div>
              </div>
            );
          })}
        </div>
      </div>
      <TabBar />
    </>
  );
};
